import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ViewUiPlus from 'view-ui-plus';
import './styles/index.less';
import VueLazyLoad from 'vue3-lazyload';
import store from './store';
// 自定义字体文件
import '@/assets/fonts/font.css';
import { VueMasonryPlugin } from 'vue-masonry';

import i18n from './language/index';
import { fontFamilies } from '@/assets/fonts/font';

const loadAdditionalFonts = import.meta.env.APP_LOAD_NIU_FONTS === 'true';
if (loadAdditionalFonts) {
  import('@/assets/fonts/font-niu.css');
}

async function bootstrap() {
  const app = createApp(App);
  app.use(store);
  app.use(VueMasonryPlugin);
  app.use(router);
  app.use(i18n);
  app.use(VueLazyLoad, {});
  app.use(ViewUiPlus);
  await router.isReady();
  app.mount('#app');
}
bootstrap();

function preloadFonts() {
  fontFamilies.forEach((fontName) => {
    const preloadDiv = document.createElement('div');
    preloadDiv.style.cssText = `
      font-family: "${fontName}";
      position: absolute;
      left: -1000px;
      visibility: hidden;
      font-size: 1px;
    `;
    preloadDiv.textContent = '.';
    document.body.appendChild(preloadDiv);

    setTimeout(() => {
      if (preloadDiv.parentNode) {
        document.body.removeChild(preloadDiv);
      }
    }, 1000);
  });
}

preloadFonts();
